'use client'

import { ReactNode } from 'react'

/**
 * ApiProvider Component
 * 
 * Provides global API service configuration and interceptor behavior
 * including:
 * - Cookie-based auth (BFF attaches Authorization: Bearer via shared helpers)
 * - Centralized error handling with toast notifications
 * - Standardized request/response handling
 * 
 * The ApiService in lib/api.ts handles all the heavy lifting.
 * This component exists as a placeholder for future enhancements
 * such as request queuing, offline mode, etc.
 */
export function ApiProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}
